module.exports = __webpack_public_path__ + "8468a86b888fb13a1ed038b0cdc3005c.pdf";